import CloseIcon from '@assets/images/common/icon/close.svg';
import Modal from '@src/layouts/Modal';
import Button from '@src/ui/elements/button/Button';

const ConfirmHidePreviewModal: React.FC<{
  onConfirm: () => void;
  onClose: () => void;
  isProcessing?: boolean;
}> = ({ onConfirm, onClose, isProcessing }) => {
  return (
    <Modal width='440px'>
      <div className='relative flex grow flex-col gap-8 p-10 py-9 md:px-6 md:py-8'>
        <div className='border-b border-b-gray-350 pb-[10px] md:pb-5'>
          <h2 className='text-lg font-semibold md:text-xl'>プレビューを非表示にしますか？</h2>
        </div>
        <p className='text-sm leading-[1.6]'>
          リンクプレビューが非表示になります。他のユーザーからも見えなくなりますがよろしいですか？
        </p>
        <div className='mt-auto flex w-full justify-between md:flex-col md:gap-4'>
          <div className='w-[172px] md:w-full'>
            <Button
              className='font-medium'
              size='m'
              fullRounded
              fullWidth
              variant='secondary'
              onClick={onConfirm}
              disabled={isProcessing}
            >
              非表示にする
            </Button>
          </div>
          <div className='w-[172px] md:w-full'>
            <Button
              className='font-medium'
              size='m'
              outline
              fullRounded
              fullWidth
              onClick={onClose}
              disabled={isProcessing}
            >
              キャンセル
            </Button>
          </div>
        </div>
        <div className='absolute right-2 top-2 md:right-[10px] md:top-3'>
          <button
            className='grid size-5 place-items-center rounded-full bg-[#F7F7F7]'
            onClick={onClose}
            disabled={isProcessing}
          >
            <img
              src={CloseIcon}
              alt=''
            />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export { ConfirmHidePreviewModal };
